define(
    'atn/messages',['common/messages'],
    function(messages) {
        'use strict';

        messages.sessionPolling = {
            notResponding: {
                heading: 'Server Not Responding',
                text: 'No response was received from the server. Please make sure your Internet connection is working. If your network is behind a proxy, please contact your network administrator to make sure your proxy settings are correct.',
            },
            logout: {
                heading: 'Invalid Session',
                text: 'Your session has ended. This may happen if you logged out from the cloud, your session timed out or if Operations Insights was upgraded.',
            },
        };
        messages.navbar = {
            dataGenerationDate : 'Last synced on '
        };

        messages.labels = {
            deleteButton: 'Delete',
            cancelButton: 'Cancel',
            okButton: 'Ok'
        };

        messages.dropDownMessages = {
            textYes: 'Yes',
            textNo: 'No',
            textField: 'text',
            valueField: 'value',
            selectText: '-Select-'
        };

        messages.graphs = {
            zeroData: 'Data is not available.',
            errorInApiCall:'Failed to fetch data for the chart.',
            noChartToDisplay: 'There is no data to display since all legends are disabled.',
            actions:{
                downloadPdf: 'Download PDF',
                downloadCsv: 'Download CSV',
                scheduleReport: 'Schedule Report'
            },
            globalDurationFilter: {
                label: 'Duration',
                defaultText: 'None'
            },
            filters: {
                customDates: 'Custom Date'
            }
        };

        messages.pdf = {
            reportName: 'Operations Insights Report',
            analytics: {
                analyticsTitle: 'Analytics',
                dashboardTitle: 'Dashboard',
                signature: 'Powered By Arista Networks.'
            }
        };

        messages.popupChoices = {
            'YES': 'Yes',
            'NO': 'No',
            'OK': 'Ok',
            'DELETE': 'Delete',
            'CANCEL': 'Cancel',
            'CONTINUE': 'Continue'
        };

        messages.deletion = {
            reporting: {
                heading: 'Delete Report',
                text: '<div>This action cannot be undone.</div><div>Are you sure you want to delete <strong>{0}<strong>?</div>'
            }
        };
        
        messages.emailnow = {
            reporting: {
                heading: 'Email Report',
                text: '<div><strong>{0}</strong> will be sent to all email recipients.</div><div>Do you wish to email the report now?</div>'
            }
        };

        messages.unsavedChanges = {
            title: 'Unsaved Changes',
            windowUnloadMessage: 'Unsaved changes will be lost if you leave this screen.',
            tabUnloadMessage: 'Unsaved changes will be lost if you leave this screen.<br /> Choose <strong>Save</strong> to update with changes and leave.<br /> OR Choose <strong>Leave</strong> without saving changes.',
            trackableMismatchFailure: 'There was an error saving the form.Please contact support.'
        };

        messages.reporting = {
            oneTimeReporting: 'One time Report',
            recurringReporting: 'Recurring Report',
            intervals: {
                DAY: 'day(s)',
                WEEK: 'week(s)',
                MONTH: 'month(s)',
                YEAR: 'year(s)'
            },
            noReportsMessage: 'No Reports Created',
            noReportsDescription: 'No reports have been created yet. Please use the \'New Report\' button to create a new report.',
            actions:{
                newReport: 'New Report',
                editSchedule: 'Edit Schedule',
                deleteReportSchedule: 'Delete',
                emailNow: 'Email Now',
                generatePdf: 'Generate Now',
                scheduleReport: 'Schedule Report',
                generatingPdf: 'Generating PDF ...'
            },
            saveSuccess: 'Report saved successfully.',
            saveFailed: 'Failed to save the report.',
            updateSuccess: 'Report updated successfully.',
            updateFailed: 'Failed to update the report.',
            pdfGenerationSuccess:'Report \'{0}\' generated successfully.',
            pdfGenerationFailed: 'Failed to generate and download the PDF report \'{0}\'.',
            emailNowSuccess: 'Report \'{0}\' sent successfully.',
            emailNowFailed: 'Failed to send report \'{0}\'.',
            deleteSuccess: 'Report \'{0}\' deleted.',
            deleteFailed: 'Failed to delete report \'{0}\'.',
            metricRequired: 'Please add at least one metric in a report.'
        };

        messages.csvDownload = {
            noChartSelected: 'Please select a chart to download in CSV format.',
            downloadSuccessful: 'Successfully downloaded the charts in CSV format.'
        };

        messages.customDate = {
            labels:{
                from: 'From',
                to: 'To'
            }
        };

        messages.forms = {
            save: 'Save',
            cancel:'Cancel',
            leave:'Leave',
            continue:'Continue',
            saving: 'Saving',
            done: 'Done',
            set: 'Set'
        };

        messages.filters = {
            custom:{
                title: 'Custom Date',
                fromDate: 'From: ',
                pointInTime: 'Data As On: ',
                toDate: 'To: ',
                startEndValidation: 'End date must be greater than start date.',
                maxDateValidation: 'Date selected must be less than the last sync date.',
                cancel: 'Cancel',
                set: 'Set',
                syncDate: 'Last Sync: '
            }
        };

        return {
            messages: messages
        };
    });
